export default "__VITE_ASSET__lQDjN9mY__"